import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth, db } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);
export { UserContext };

export const UserProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [rol, setRol] = useState(null);
  const [nombre, setNombre] = useState('');
  const [cargando, setCargando] = useState(true);
  const [tasaBCV, setTasaBCV] = useState(0);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (usuarioFirebase) => {
      if (usuarioFirebase) {
        try {
          const docRef = doc(db, 'usuarios', usuarioFirebase.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            const data = docSnap.data();
            if (data.rol) {
              setUsuario(usuarioFirebase);
              setRol(data.rol);
              setNombre(data.nombre || '');
            } else {
              console.warn('El usuario no tiene un rol asignado.');
              setUsuario(null);
              setRol(null);
              setNombre('');
            }
          } else {
            console.warn('No se encontró documento del usuario en Firestore.');
            setUsuario(null);
            setRol(null);
            setNombre('');
          }
        } catch (error) {
          console.error('Error obteniendo datos del usuario:', error);
          setUsuario(null);
          setRol(null);
          setNombre('');
        }
      } else {
        setUsuario(null);
        setRol(null);
        setNombre('');
      }
      setCargando(false);
    });

    return () => unsubscribe();
  }, []);

  const cerrarSesion = async () => {
    try {
      await signOut(auth);
      setUsuario(null);
      setRol(null);
      setNombre('');
    } catch (error) {
      console.error('Error al cerrar sesión', error);
    }
  };

  return (
    <UserContext.Provider
      value={{
        usuario,
        setUsuario,
        rol,
        setRol,
        nombre,
        cargando,
        tasaBCV,
        setTasaBCV,
        cerrarSesion
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
